import { Record } from 'immutable';
const List = Record({
  listId: undefined,
  name: undefined,
  metaData: {},
  portalId: undefined
});
export default List;